export function ready() {
    //TOPはローダー有り
    const mv = document.querySelector(".mv");
    const loader = document.querySelector(".l-loader");

    const setReadyClass = () => {
        loader && loader.classList.remove("-active");
        document.body.classList.add("-ready");
        setTimeout(() => {
            document.body.classList.add("-readyend");
        }, 2000);
    };

    if (mv) {
        const isNrw = window.innerWidth <= 865 ? "_nrw" : "";
        const mvImages = [
            `./assets/img/top/mv/visual/ph_visual_1${isNrw}.jpg`,
            `./assets/img/top/mv/visual/ph_visual_2${isNrw}.jpg`,
            `./assets/img/top/mv/visual/ph_visual_3${isNrw}.jpg`,
        ];

        const loadFlags = [false, false, false];

        mvImages.forEach((el, index) => {
            const img = new Image();
            img.src = el;
            img.addEventListener("load", () => {
                loadFlags[index] = true;
            });
        });

        const loadLoop = () => {
            if (loadFlags[0] === true && loadFlags[1] === true && loadFlags[2] === true) {
                setTimeout(() => {
                    setReadyClass();
                }, 500);
            } else {
                setTimeout(loadLoop, 100);
            }
        };

        loadLoop();
    } else {
        //通常下層ページではローディングはしない
        setReadyClass();
    }
}
